<form [formGroup]="form">
  <div class="summary" *ngIf="template">
    <ng-container
      *ngTemplateOutlet="
        summary;
        context: { label: 'creator', value: template.metadata.created_by?.name }
      "></ng-container>
    <ng-container
      *ngTemplateOutlet="
        summary;
        context: { label: 'last-modifier', value: template.metadata.last_modified_by?.name }
      "></ng-container>
    <ng-container
      *ngTemplateOutlet="
        summary;
        context: { label: 'create-date', value: template.metadata.created_at }
      "></ng-container>
    <ng-container
      *ngTemplateOutlet="
        summary;
        context: { label: 'last-modification-date', value: template.metadata.last_modified_at }
      "></ng-container>
  </div>

  <div>
    <mat-form-field>
      <mat-label [translate]="'parameters/kakaotalk-templates/name'"></mat-label>
      <input matInput formControlName="name" [maxlength]="templateNameMaxLength" />
      <span class="text-muted" matSuffix>{{ form.value.name?.length || 0 }}/{{ templateNameMaxLength }}</span>
      <mat-hint [translate]="'parameters/kakaotalk-templates/details/main/name/hint'"></mat-hint>
    </mat-form-field>
  </div>

  <div>
    <app-select
      [items]="languageList"
      [multiple]="true"
      [control]="form.get('languages')"
      [labelKey]="'parameters/kakaotalk-templates/details/main/languages'"></app-select>
  </div>

  <div>
    <app-select
      [items]="accountList"
      [control]="form.controls.siteId"
      [optionTemplateName]="'site-icon'"
      [labelKey]="'parameters/kakaotalk-templates/account-id'"></app-select>
  </div>

  <div>
    <app-select
      [items]="usagesList"
      [control]="form.controls.usages"
      [multiple]="true"
      [labelKey]="'parameters/kakaotalk-templates/details/main/usages'"></app-select>
  </div>

  <ng-template #summary let-label="label" let-value="value">
    <div class="summary-details">
      <label class="text-muted" [translate]="'parameters/kakaotalk-templates/details/main/' + label"></label>
      <span class="value">{{ value }}</span>
    </div>
  </ng-template>
</form>
